//@flow
import { urlsConstants } from './../_constants/urls.constant';
import { defaultService } from './defaultService';

export const modeloReceituarioService = {
  doGet,
  doSave,
  findByFiltro,
  exportToExcel,
  findAll,
  imprimir,
  doDelete,
};

function findAll() {
  return defaultService.doGet(
    `${urlsConstants.PROTOCOLO_ATENDIMENTO_RECEITUARIO}findAll`
  );
}

function findByFiltro(options: Options, filter: any): Promise<Array<>> {
  return defaultService.findByFiltro(
    `${urlsConstants.PROTOCOLO_ATENDIMENTO_RECEITUARIO}list`,
    options,
    filter
  );
}

function doGet(id) {
  return defaultService.doGet(
    `${urlsConstants.PROTOCOLO_ATENDIMENTO_RECEITUARIO}${id}`
  );
}

function doDelete(id) {
  return defaultService.doDelete(
    `${urlsConstants.PROTOCOLO_ATENDIMENTO_RECEITUARIO}${id}`
  );
}

function doSave(entity: any) {
  return defaultService.doSave(
    urlsConstants.PROTOCOLO_ATENDIMENTO_RECEITUARIO,
    entity
  );
}

function exportToExcel(filter, fields, labels) {
  return defaultService.exportToExcel(
    'estabelecimento',
    filter,
    fields,
    labels
  );
}

function imprimir(values) {
  return defaultService.doPost(
    `${urlsConstants.PROTOCOLO_ATENDIMENTO_RECEITUARIO}imprimir`,
    values
  );
}
